import React from "react";
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import AdminTable from "../Helpers/AdminTable";
import TableTitle from "../Helpers/TableTitle";
import { useState } from "react";
import SureModal from "src/components/Modals/SureModal";
import { stocksAction } from "src/store/Slices/Administrator/StocksSlice";
// import AddEditStocksModal from './Modals/AddEditStocksModal'
// import MobileStocks from './Mobile/MobileStocks'
import { clubTypesAction } from "src/store/Slices/Administrator/ClubTypesSlice";
import {
    formatIsoToDateNew,
    formatIsoToTime,
    formateDate,
} from "src/components/helpers/formateDate";
import AddEditClubTypesModal from "./Modals/AddEditClubTypes";
import AntdMobileTable from "src/components/AntdMobileTable/AntdMobileTable";

const clubTypes = ({ mnemo }) => {
    const searchInput = useRef(null);
    const items = [
        {
            key: "1",
            label: "Редактировать",
            onClick: () => {
                setIsOpenAddEditModal({ open: true, flag: "edit" });
            },
            disabled: !mnemo?.children?.find((el) => el.mnemo === "updateBtn"),
        },
        {
            key: "2",
            label: "Удалить",
            onClick: () => {
                setIsOpenDeleteModal(true);
            },
            disabled: !mnemo?.children?.find((el) => el.mnemo === "deleteBtn"),
        },
    ];

    const filterOptionsArr = [
        { label: "Фильрация", value: 0, index: undefined },
        { label: "По номеру", value: 1, index: "id", title: "Клуб" },
        {
            label: "По наименование",
            value: 2,
            index: "name",
            title: "Наименование",
        },
    ];

    const dispatch = useDispatch();

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [clubTypeInfo, setClubTypeInfo] = useState();
    const [isDeleted, setIsDeleted] = useState(false);
    const [isOpenAddEditModal, setIsOpenAddEditModal] = useState({
        open: false,
        flag: "",
    });
    const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);

    // STORE
    const clubTypesList = useSelector(
        (state) => state.ClubTypesSlice.clubTypesList
    );
    const clubsTypesLoading = useSelector(
        (state) => state.ClubTypesSlice.clubsTypesLoading
    );

    const searchItemsMap = (keys, values) => {
        const formattedItems = {};
        if (keys && values) {
            keys.forEach((key, index) => {
                if (values[index] && values[index][0]) {
                    if (key === "id") {
                        formattedItems["IdFrom"] = values[index][0];
                        formattedItems["IdTo"] = values[index][1];
                    } else {
                        formattedItems[key] = values[index][0];
                    }
                }
            });
            return formattedItems;
        }
    };

    const handleTableChange = (pagination, filters, sorter) => {
        const payload = searchItemsMap(
            Object.keys(filters),
            Object.values(filters)
        );
        dispatch(
            clubTypesAction({
                flag: "get",
                value: {
                    isDeleted: isDeleted,
                    Count: pagination.pageSize,
                    Offset: pagination.pageSize * (pagination.current - 1),
                    OrderBy: sorter?.column?.dataIndex,
                    isDesc: sorter.order
                        ? sorter.order === "ascend"
                            ? true
                            : false
                        : undefined,
                    ...payload,
                },
            })
        );
        setPage(pagination.current);
        setPageSize(pagination.pageSize);
    };

    const showDeletedItems = (value) => {
        setIsDeleted(value);
        dispatch(clubTypesAction({ flag: "get", value: { isDeleted: value } }));
        setPage(1);
        setPageSize(20);
    };

    const clickOnAction = (element) => {
        setClubTypeInfo(element);
    };

    const handlePaginationChange = (page, pageSize) => {
        dispatch(
            clubTypesAction({
                flag: "get",
                value: {
                    count: pageSize,
                    offset: pageSize * (page - 1),
                },
            })
        );
        setPage(page);
        setPageSize(pageSize);
    };

    const onClickSearchItem = (selectedKeys, dataIndex) => {
        setPage(1);
        setPageSize(20);
        dispatch(
            clubTypesAction({
                flag: "get",
                value: {
                    isDeleted: isDeleted,
                    [`${dataIndex}`]: selectedKeys[0],
                },
            })
        );
    };

    useEffect(() => {
        dispatch(clubTypesAction({ flag: "get" }));
    }, []);

    const onClickDelete = () => {
        dispatch(
            clubTypesAction({ flag: "delete", value: { id: clubTypeInfo.id } })
        ).then(() => {
            dispatch(clubTypesAction({ flag: "get" }));
            setIsOpenDeleteModal(false);
        });
        setPage(1);
        setPageSize(20);
    };

    return (
        <>
            <AddEditClubTypesModal
                visible={isOpenAddEditModal}
                setVisible={setIsOpenAddEditModal}
                clubTypeInfo={clubTypeInfo}
                setPage={setPage}
                setPageSize={setPageSize}
            />
            <SureModal
                visible={isOpenDeleteModal}
                setVisible={setIsOpenDeleteModal}
                onClickYes={onClickDelete}
            />
            {window.innerWidth >= 768 ? (
                <AdminTable
                    page={page}
                    setPage={setPage}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    onChange={handleTableChange}
                    loading={clubsTypesLoading}
                    onClickRowOne={(record) => {
                        setClubTypeInfo(record);
                    }}
                    columns={clubTypesList}
                    rows={clubTypesList?.data?.value?.rows}
                    total={clubTypesList?.data?.value?.totalCount}
                    items={items}
                    title={() => (
                        <TableTitle
                            isDeleted={isDeleted}
                            showDeletedItems={showDeletedItems}
                            onClickOpenModal={() => {
                                setIsOpenAddEditModal({
                                    open: true,
                                    flag: "add",
                                });
                            }}
                            mnemoButton={
                                !mnemo?.children?.find(
                                    (el) => el.mnemo === "insertBtn"
                                )
                            }
                            mnemoSwitcher={
                                !mnemo?.children?.find(
                                    (el) => el.mnemo === "isDeletedBtn"
                                )
                            }
                        />
                    )}
                />
            ) : (
                <AntdMobileTable
                    items={items}
                    page={page}
                    setPage={setPage}
                    setPageSize={setPageSize}
                    elementsList={clubTypesList}
                    elementsListLoading={clubsTypesLoading}
                    setIsOpenAddEditModal={setIsOpenAddEditModal}
                    handlePaginationChange={handlePaginationChange}
                    onChange={handleTableChange}
                    filterOptionsArr={filterOptionsArr}
                    clickOnAction={clickOnAction}
                    searchInput={searchInput}
                    onClickSearchItem={onClickSearchItem}
                />
            )}
        </>
    );
};

export default clubTypes;
